import {BaseService} from "./base.service";

class AffiliateDependentsService extends BaseService {

    constructor() {
        super('api/affiliates-dependents');
    }

    getSkuClient(role_id,sku) {
        //EL ROLE ID DEBE SER 0,8,9 QUE SON EL CONTRATANTE, AFILIADO T Y D
        return this.http.get(`api/get-sku-client/${role_id}/${sku}`).then(response => response.data).catch(err => err.message);
    }

    getDependentsByTitular(titular_id) {
        return this.http.get(`api/get-dependent-by-sku/${titular_id}`).then(response => response.data).catch(err => err.message);
    }

    restoreDependent(id) {
        return this.http.get(`api/restore-dependent/${id}`).then(response => response.data).catch(err => err.message);
    }

    cancelDependent(id) {
        return this.http.get(`api/cancel-dependent/${id}`).then(response => response.data).catch(err => err.message);
    }

}

export const affiliatedependentsService = new AffiliateDependentsService();
